// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zamazenta_crowned: PokeData = {
  "id": 10189,
  "name": "zamazenta-crowned",
  "height": 29,
  "weight": 7850,
  "base_experience": 360,
  "types": [
    PokeType.FIGHTING,
    PokeType.STEEL
  ],
  "api_moves": [
    "bite",
    "quick-attack",
    "slash",
    "metal-claw",
    "crunch",
    "iron-defense",
    "howl",
    "metal-burst",
    "close-combat",
    "giga-impact",
    "iron-head",
    "wide-guard",
    "moonblast",
    "laser-focus"
  ],
  "moves": [
    "bite",
    "quick-attack",
    "metal-claw",
    "crunch",
    "metal-burst",
    "close-combat",
    "moonblast",
    "meteor-mash",
    "drain-punch",
    "behemoth-bash",
    "magnet-pull",
    "coaching",
    "magnet-bomb"
  ],
  "evolution_chain": {
    "id": 468,
    "item": null,
    "species": [
      {
        "name": "zamazenta",
        "order": 889,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 127,
    "speed": 141,
    "ability_power": 132
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
